<template>
  <b-row id="professional-platform" class="section-white-list">
    <!-- <div class="bg-image" v-if="!$store.getters['session/isLogged']"></div> -->

    <b-col md="12" lg="6" class="content my-auto">
      <div class="title-ctn">
        <h4 class="mb-3">{{ $t('abogalitypro.professional-platform.orange-title') }}</h4>
        <h3>{{ $t('abogalitypro.professional-platform.title') }}</h3>
      </div>
      <div class="subtitle">
        <div class="subtitle-list subtitle-list-large my-5">
          <b-row>
            <b-col class="tick-mobile" cols="2">
              <p>
                <rounded-check-icon/>
              </p>
            </b-col>
            <b-col cols="10">
              <span v-html="$t('abogalitypro.professional-platform.text1')">
              </span>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="tick-mobile" cols="2">
              <p>
                <rounded-check-icon/>
              </p>
            </b-col>
            <b-col cols="10">
              <span v-html="$t('abogalitypro.professional-platform.text2')">
              </span>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="tick-mobile" cols="2">
              <p>
                <rounded-check-icon/>
              </p>
            </b-col>
            <b-col cols="10">
              <span v-html="$t('abogalitypro.professional-platform.text3')">
              </span>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="tick-mobile" cols="2">
              <p>
                <rounded-check-icon/>
              </p>
            </b-col>
            <b-col cols="10">
              <span v-html="$t('abogalitypro.professional-platform.text4')">
              </span>
            </b-col>
          </b-row>
        </div>
        <b-row>
          <h4>{{ $t('abogalitypro.professional-platform.orange-title-final') }}</h4>
        </b-row>
      </div>
    </b-col>
    <b-col md="12" lg="6" class="py-sm-0 py-lg-5">
      <div class="col-bg ml-lg-auto">
      </div>
    </b-col>
  </b-row>
</template>

<script>
import RoundedCheckIcon from '@/components/base/icons/RoundedCheckIcon.vue'
/* import es from '@/lang/es/public/views/abogalitypro.json'
import en from '@/lang/en/public/views/abogalitypro.json' */

export default {
  components: {
    RoundedCheckIcon
  }
/*   i18n: {
    messages: {
      es,
      en,
      mx: es
    }
  } */

}
</script>

<style lang="scss" scoped>
/* @import '../../../../static-appopensalud/css/openlegal/colors.scss'; */

#professional-platform {
  @include media(tablets, mobile) {
    flex-direction: column-reverse;
  }
  .col-bg {
    background-blend-mode: overlay;
     background-position: center;
    background-image: url('/static-appopensalud/img/bgs/abogalitypro/abogality-professional-platform.png');
    @include media(mobile, tablets) {
      background-blend-mode: overlay;

      width: 100%;
      @include main-block-height();
      background-size: cover;
      top: 0;
      right: 0;
    }
  }
}

h4 {
    color: $blue;
  }

.title-ctn {
  h3 {
    color: $black;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/views/abogalitypro/AbogalityProfessionalPlatform.vue